import { z } from 'zod';
export const businessTypes = ['sports_venue', 'fitness', 'beauty_wellness', 'professional_services', 'education', 'events', 'coworking', 'rentals', 'other'];
export const businessTypeSchema = z.enum(businessTypes);
//# sourceMappingURL=platform-directory.js.map